import { AdminFormAction, AdminFormActionTypes } from '@completion/actions';
import { AdminFormDto, AdminFormInfo, AdminFormListItemDto, FormConnectionDto, PaginatedResponse } from '@completion/models';

export interface AdminFormState {
  currentForm: AdminFormDto | null;
  forms: AdminFormListItemDto[];
  formsResponse: PaginatedResponse<AdminFormListItemDto> | null;
  connections: FormConnectionDto[] | null;
  formInfo: AdminFormInfo | null;
  formInfoLoading: boolean;
  notFound: boolean | null;
}

export const initialState: AdminFormState = {
  currentForm: null,
  forms: [],
  formsResponse: null,
  connections: null,
  formInfo: null,
  formInfoLoading: false,
  notFound: null,
};

export function adminFormReducer(state: AdminFormState = initialState, action: AdminFormAction): AdminFormState {
  switch (action.type) {
    case AdminFormActionTypes.AdminFormInfoLoad:
      return {
        ...state,
        formInfo: null,
        formInfoLoading: true,
      };

    case AdminFormActionTypes.AdminFormInfoLoadSuccess:
      return {
        ...state,
        formInfo: action.formInfo,
        formInfoLoading: false,
      };

    case AdminFormActionTypes.AdminFormInfoLoadFail:
      return {
        ...state,
        formInfo: null,
        formInfoLoading: false,
      };

    case AdminFormActionTypes.AdminFormInfoClear:
      return {
        ...state,
        formInfo: null,
        formInfoLoading: false,
      };

    case AdminFormActionTypes.AdminFormConnectionsLoadSuccess:
      return {
        ...state,
        connections: action.connections,
      };

    case AdminFormActionTypes.AdminFormLoadSuccess:
    case AdminFormActionTypes.AdminFormCreateSuccess:
    case AdminFormActionTypes.AdminFormUpdateSuccess:
    case AdminFormActionTypes.AdminFormUpdateStatusSuccess:
    case AdminFormActionTypes.AdminFormAddConnectionsSuccess:
      return {
        ...state,
        currentForm: action.form,
        notFound: false,
      };

    case AdminFormActionTypes.AdminFormsListLoadSuccess:
      return {
        ...state,
        forms: action.formsResponse.content,
        formsResponse: action.formsResponse,
      };

    case AdminFormActionTypes.AdminFormLoadFail:
    case AdminFormActionTypes.AdminFormsListLoadFail:
      return {
        ...state,
        notFound: action.error?.status === 404,
      };

    case AdminFormActionTypes.AdminFormDeleteSuccess:
    case AdminFormActionTypes.AdminFormUnload:
      return initialState;

    default:
      return state;
  }
}
